import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import Rectangle from '../../components/Rectangle/Rectangle';
import { aboutPt, aboutEng } from '../../translation/about';
import { qualitiesPt, qualitiesEng } from '../../translation/qualities';
import './About.scss';

function About() {
    let { languageIndex } = useContext(LanguageContext);
    let title = !languageIndex ? 'Quem somos' : 'About us';
    let about = !languageIndex ? aboutPt :  aboutEng;
    let qualities = !languageIndex ? qualitiesPt :  qualitiesEng;

    return (
        <div className='about'>
            <div className='about-column who' data-aos='fade-right' >
                <h2 className='who-title'>{ title }</h2>
                <p>{ about }</p>
            </div>

            <div className='grid-holder' data-aos='fade-left' >
                <div className='about-column qualities'>
                    {qualities.map(quality =>
                        <Rectangle
                        content={quality}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default About;